import axios from "axios"
const baseUrl = process.env.REACT_APP_API_URL

export const sendContact = (formData) => {
  const { name, email, phn, message } = formData

  const html = `<html>
  <head>
    <meta name="viewport" content="width=device-width" />
    <meta http-equiv="Content-Type" content="text/html; charset=UTF-8" />
  </head>
  <body>
    <table
      style="
        background-color: #fafafa;
        width: 100% !important;
        height: 100%;
        background-color: #fafafa;
        padding: 20px;
        font-family: 'Helvetica Neue', 'Helvetica', Helvetica, Arial,
          'Lucida Grande', sans-serif;
        font-size: 100%;
        line-height: 1.6;
      "
    >
      <tr>
        <td></td>
        <td
          style="
            background-color: #ffffff;
            border: 1px solid #eeeeee;
            background-color: #ffffff;
            border-radius: 5px;
            display: block !important;
            max-width: 600px !important;
            margin: 0 auto !important;
            clear: both !important;
          "
        >
          <div
            style="
              padding: 20px;
              max-width: 600px;
              margin: 0 auto;
              display: block;
            "
          >
            <table style="width: 100%">
              <tr>
                <td>
                  <h1
                    style="
                      font-weight: 200;
                      font-size: 36px;
                      color: #333333;
                      text-align: center;
                    "
                  >
                    DOCKIGNMATE
                  </h1>
                  <p
                    style="
                      text-align: center;
                      display: block;
                      padding-bottom: 20px;
                      margin-bottom: 20px;
                      border-bottom: 1px solid #dddddd;
                    "
                  ></p>

                  <p
                    style="
                      margin-bottom: 10px;
                      font-weight: normal;
                      font-size: 16px;
                      color: #333333;
                    "
                  >
                    Name: ${name}
                  </p>
                  <h2
                    style="
                      font-weight: 200;
                      font-size: 16px;
                      margin: 20px 0;
                      color: #333333;
                    "
                  >
                    Email: ${email}
                  </h2>
                  <h2
                    style="
                      font-weight: 200;
                      font-size: 16px;
                      margin: 20px 0;
                      color: #333333;
                    "
                  >
                    Phone: ${phn}
                  </h2>
                  <h2
                    style="
                      font-weight: 200;
                      font-size: 16px;
                      margin: 20px 0;
                      color: #333333;
                    "
                  >
                    Message: ${message}
                  </h2>

                  <p
                    style="
                      text-align: center;
                      display: block;
                      padding-top: 20px;
                      font-weight: bold;
                      margin-top: 30px;
                      color: #666666;
                      border-top: 1px solid #dddddd;
                    "
                  >
                    DOCKIGNMATE
                  </p>
                </td>
              </tr>
            </table>
          </div>
        </td>
        <td></td>
      </tr>
    </table>
  </body>
</html>
`

  let data = JSON.stringify({
    "subject": `Dockingmate: New message from ${name}`,
    "message": html,
    "mailBodyType": "HTML"
  });

  let config = {
    method: 'post',
    maxBodyLength: Infinity,
    url: `${baseUrl}/api/contact/sendmailforcontactus`,
    headers: {
      'Content-Type': 'application/json'
    },
    data: data
  };

  const res = axios.request(config)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log("error in send contact: ", error);
      return error.response;
    });
  return res;
}

export const getHomepageContent = () => {
  let config = {
    method: 'get',
    url: `${baseUrl}/api/homepagecontent/getallhomepagecontents`,
  };

  const res = axios.request(config)
    .then((response) => {
      return response.data
    })
    .catch((error) => {
      console.log("error in getHomepageContent: ", error);
      return error.response;
    });
  return res;
}